import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDioceseList } from '../../../global/ducks/wam-api';
import { TcsmStates } from '../../../root/tcsm-model';
import { setDioceseList } from '../features/institutions/institution-slice';


export function useDioceseList() {
	const dispatch = useDispatch();
	const dioceseInstitutionListLoaded = useSelector<TcsmStates, boolean>(state => state.institutionState?.dioceseListLoaded);
	useEffect(() => {
		dispatch(getDioceseList((data) => dispatch(setDioceseList(data?.data))));
	}, []);

	return dioceseInstitutionListLoaded;
}